"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = require("bind-decorator");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_toastify_1 = require("react-toastify");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const product_1 = require("../helper/product");
const LicenseStore_1 = __importDefault(require("../stores/LicenseStore"));
class ChangeUsageInformationModal extends react_1.default.Component {
    usageInformation = this.props.data.usage ?? '';
    isSubmitting = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            usageInformation: mobx_1.observable,
            isSubmitting: mobx_1.observable,
        });
    }
    render() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "modal-header znd-modal__header" },
                react_1.default.createElement("h3", { className: "znd-modal__title" }, (0, translation_1.t)('modal.software_edit_usage.title')),
                react_1.default.createElement("div", { className: "znd-modal__close", onClick: this.props.onCancel },
                    react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.close }))),
            react_1.default.createElement("form", { onSubmit: this.onSubmit },
                react_1.default.createElement("div", { className: "modal-body znd-modal__body" },
                    react_1.default.createElement("h3", { className: "t-body-small znd-change-usage-modal__label" }, (0, translation_1.t)('modal.software_edit_usage.license_label')),
                    react_1.default.createElement("p", null, `${this.props.data.name ?? ''} - ${this.props.externalId}`),
                    react_1.default.createElement("h3", { className: "t-body-small znd-change-usage-modal__label" },
                        (0, translation_1.t)('modal.software_edit_usage.usage.label'),
                        react_1.default.createElement("small", { className: "pl-2" }, (0, translation_1.t)('modal.software_edit_usage.usage.hint'))),
                    react_1.default.createElement("input", { className: "form-control", key: "comment", maxLength: 30, onChange: (0, mobx_1.action)((event) => (this.usageInformation = event.target.value)), placeholder: (0, translation_1.t)('modal.software_edit_usage.usage.placeholder'), required: false, value: this.usageInformation })),
                react_1.default.createElement("div", { className: "modal-footer znd-modal__footer" },
                    react_1.default.createElement(Button_1.default, { className: "justify-content-center", onClick: this.props.onCancel, text: (0, translation_1.t)('modal.software_edit_usage.cancel'), variant: ButtonVariant_1.default.secondary }),
                    react_1.default.createElement(Button_1.default, { className: "justify-content-center", disabled: this.isSubmitting, text: (0, translation_1.t)('modal.software_edit_usage.submit'), type: 'submit', variant: ButtonVariant_1.default.primary })))));
    }
    onSubmit(event) {
        event.preventDefault();
        this.isSubmitting = true;
        LicenseStore_1.default.updateLicenseUsage(this.props.data.id, this.usageInformation)
            .then(() => {
            (0, product_1.updateUsage)(this.props.data.id, this.usageInformation);
            LicenseStore_1.default.triggerObservables();
            react_toastify_1.toast.success((0, translation_1.t)('modal.software_edit_usage.send_success'));
            this.props.onDone();
        })
            .catch(() => {
            react_toastify_1.toast.error((0, translation_1.t)('modal.software_edit_usage.send_error'));
        })
            .finally(() => {
            this.isSubmitting = false;
        });
    }
}
__decorate([
    bind_decorator_1.bind
], ChangeUsageInformationModal.prototype, "onSubmit", null);
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(ChangeUsageInformationModal));
